<template>
  <VDialog v-model="isShowModal" max-width="500">
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-information-outline" class="mr-2" />
        Confirmation
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VCardText>
          <div class="d-flex flex-column align-center justify-center">
            <VIcon icon="mdi-information" color="warning" size="64" class="my-2" />
            <p class="text-center">
              Are you sure you want to delete this question (<b>{{ question.value }}</b
              >)? This action cannot be undone.
            </p>
          </div>
          <VRow class="mt-4">
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="red" block flat @click="handleSubmit()">
                Delete
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VCardText>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import requestsService from '@/services/requests-service/requests.service';
// Test
import { successDeleteQuestionText, errorDeleteQuestionText } from '@/text/snackbarsText';
export default {
  name: 'DeleteCategoryModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object
    },
    question: {
      type: Object
    },
    requestId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'deleted', 'close'],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleSubmit() {
      this.isLoading = true;
      try {
        const questionData = {
          questionId: this.question.questionId,
          requestId: this.requestId
        };
        await requestsService.deleteQuestion(questionData);
        this.showSnackbar({ text: successDeleteQuestionText, color: 'green' });
        this.handleSuccess(this.category.categoryId, this.question.questionId);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: errorDeleteQuestionText, color: 'red' });
      } finally {
        this.isLoading = false;
      }
    },

    handleSuccess(categoryId, questionId) {
      this.$emit('deleted', { categoryId: categoryId, questionId: questionId });
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
    }
  }
};
</script>
